export default __webpack_public_path__ + "static/media/69.03b790a3.gif";